function NewQuotaParameter() {
    return {
        id: null,       
        negate: false,		
		parameterValue: {},
        isDemoQuestionParam: true
      }
}
export default NewQuotaParameter;